var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroThree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 339,
    viewBox: "0 0 353 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.676 0.077704C91.4669 -2.55461 13.3271 62.0015 1.52061 146.699C-11.3867 239.307 59.6553 322.631 147.071 335.972C255.801 352.573 361.263 256.541 351.793 152.363C344.659 73.8761 273.376 2.74772 181.676 0.077704Z",
    fill: "#F4F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.44 251.496C140.616 250.978 144.895 247.932 145.682 246.678C150.926 238.332 161.76 223.346 160.059 213.068C159.768 211.312 151.7 210.505 150.423 209.001C145.404 207.237 143.554 206.933 139.605 202.919C127.949 191.052 148.85 164.252 120.642 158.583C99.9842 154.432 83.8205 163.103 82.6905 131.832C81.5604 100.56 50.9811 46.5884 20.4857 71.7012C2.98396 86.1156 24.8647 110.505 17.2439 130.994C9.99778 150.47 19.4505 164.875 40.2803 173.905C61.1101 182.936 51.509 192.581 47.653 210.762C43.0197 232.615 75.9041 232.929 91.1092 231.778C103.341 230.851 135.126 236.747 138.44 251.496Z",
    fill: "url(#paint0_linear_5_256)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8193 61.3982L28.1842 61.3557C32.5073 99.5801 45.7698 135.192 66.5376 164.344C77.2335 179.358 89.8331 192.535 103.985 203.513C118.767 214.962 135.248 224.033 152.83 230.395L152.708 230.746C135.088 224.368 118.573 215.277 103.76 203.801C89.5801 192.801 76.9562 179.603 66.2396 164.56C45.4341 135.358 32.1485 99.6847 27.8193 61.3982Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5121 219.241C62.8641 210.997 94.6416 207.471 115.349 211.379L115.28 211.744C94.6355 207.852 62.9578 211.362 44.6642 219.58L44.5121 219.241Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.01 162.644C125.349 160.631 125.731 158.585 126.158 156.504L126.522 156.579C123.663 170.553 122.772 183.051 123.878 193.73C125.388 208.303 130.634 218.953 139.472 225.385L139.253 225.685C130.326 219.189 125.029 208.45 123.508 193.768C122.562 184.642 123.068 174.19 125.01 162.644Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7883 146.317C26.081 145.411 47.6711 147.047 63.6706 160L63.437 160.289C47.53 147.412 26.0385 145.785 10.8102 146.688L10.7883 146.317Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6463 97.5171C42.1028 94.8198 42.7013 92.1485 43.4393 89.5143C45.9183 80.6187 50.1295 71.3898 55.6289 62.8153L55.9415 63.016C39.6611 88.4062 40.1841 108.661 41.9443 118.478L41.5794 118.544C40.3849 111.899 40.4116 104.854 41.6463 97.5171Z",
    fill: "#FCFDFE"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.791 194.747C218.854 194.84 214.56 193.332 213.603 192.477C207.234 186.792 194.616 176.921 193.561 167.956C193.381 166.425 199.904 163.82 200.606 162.256C204.359 159.579 205.826 158.889 208.147 154.592C214.998 141.914 191.165 124.628 213.278 113.135C229.475 104.715 245.012 108.049 238.435 81.7511C231.858 55.4536 244.35 3.17834 275.768 16.7559C293.798 24.547 281.441 50.1014 292.712 65.3284C303.417 79.7964 299.017 94.0588 283.848 106.579C268.68 119.1 278.989 124.825 286.569 139.034C295.675 156.105 268.375 164.268 255.451 166.962C245.044 169.136 220.004 181.68 220.791 194.747Z",
    fill: "url(#paint1_linear_5_256)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M269.768 56.0581C270.69 40.9382 269.847 25.4447 267.214 9.94281L266.849 10.0048C272.435 42.8552 269.953 75.6801 259.672 104.929C254.377 119.993 247.058 133.985 237.917 146.517C228.366 159.597 216.83 171.106 203.727 180.627L203.946 180.928C217.08 171.384 228.643 159.847 238.217 146.735C247.377 134.17 254.716 120.15 260.02 105.053C265.469 89.5484 268.732 73.0392 269.768 56.0581Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M291.223 145.312C273.962 142.86 246.659 147.56 230.359 155.792L230.526 156.122C246.768 147.921 273.973 143.236 291.171 145.68L291.223 145.312Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M220.231 155.713C220.469 151.825 220.182 147.624 219.372 143.111C217.72 133.922 213.965 123.698 208.211 112.725L207.882 112.897C213.619 123.837 217.362 134.024 219.006 143.176C221.25 155.661 219.444 165.781 213.638 173.252L213.931 173.479C217.701 168.628 219.805 162.68 220.231 155.713Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M301.844 76.877L301.761 76.5121C288.81 79.4315 271.229 85.9855 261.019 100.618L261.323 100.831C271.465 86.2957 288.956 79.7806 301.844 76.877Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M269.488 60.8119C268.669 52.9052 265.799 44.928 260.963 37.0919C256.76 30.28 251.032 23.6068 244.396 17.7923L244.153 18.0709C263.798 35.288 268.228 52.2654 269.121 60.852L269.488 60.8119Z",
    fill: "#FCFDFE"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M212.604 288.142C203.209 284.154 193.883 279.945 184.627 275.514C184.431 275.617 186.774 253.542 199.77 245.04C225.354 228.674 216.974 205.801 216.138 193.325C214.288 175.566 222.053 158.901 238.577 162.937C256.996 167.059 268.194 137.715 272.063 109.371C273.005 95.3019 289.896 82.3435 303.486 81.9226C317.443 81.1697 328.098 92.9543 325.06 120.696C322.946 153.184 295.502 165.946 283.094 179.265C270.895 192.339 286.809 209.652 267.889 219.118C251.807 227.72 233.232 232.073 235.272 248.686C237.526 265.177 232.88 276.957 212.604 288.142Z",
    fill: "url(#paint2_linear_5_256)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M300.242 102.935C302.133 93.2444 302.776 83.3517 302.155 73.4978L301.79 73.5209C303.028 93.1246 299.272 112.507 290.311 132.777C282.295 150.909 270.861 168.236 259.804 184.99C255.674 191.248 251.404 197.718 247.337 204.187C219.883 243.462 198.886 285.686 198.838 285.879L199.203 285.968L199.023 285.924L199.201 285.978C199.68 284.64 221.321 242.058 247.649 204.392C251.719 197.92 255.989 191.451 260.116 185.196C271.186 168.426 282.626 151.088 290.654 132.927C295.143 122.759 298.333 112.805 300.242 102.935Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M329.5 116.269L329.453 116.133L329.545 115.919C329.326 115.824 329.016 116.032 321.688 121.758C312.215 129.153 294.582 142.923 280.529 152.178L280.733 152.487C294.798 143.221 312.44 129.449 321.917 122.05C325.969 118.882 329.168 116.385 329.5 116.269Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M288.776 136.799C289.823 125.737 288.252 115.156 284.229 106.201C281.036 99.0899 277.266 95.0964 276.201 94.2583C275.967 94.0746 275.855 94.0284 275.74 94.0685L275.872 94.4493C275.84 94.4599 275.806 94.4599 275.774 94.4493C276.215 94.622 280.031 98.2907 283.382 105.32C286.416 111.68 289.747 122.297 288.377 136.757L288.776 136.799Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M233.72 219.766C235.666 209.697 235.282 198.52 232.558 186.392C230.628 177.799 227.583 169.08 223.507 160.482C223.294 160.033 223.126 159.679 223.108 159.612L222.72 159.719C222.746 159.814 222.849 160.033 223.143 160.655C227.206 169.231 230.241 177.921 232.166 186.484C235.852 202.906 235.236 217.573 230.329 230.077L230.703 230.224C232.026 226.837 233.036 223.337 233.72 219.766Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280.348 207.096L280.258 206.893C280.064 206.784 255.038 201.642 238.387 217.501L238.644 217.77C255.158 202.04 279.873 207.158 280.103 207.229L280.165 207.055L280.178 207.241L280.348 207.096Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M203.292 276.872C204.442 270.927 204.064 261.278 197.733 246.661C197.564 246.272 197.419 245.931 197.403 245.872L197.239 245.912L197.02 245.819C196.976 245.925 196.975 245.924 197.363 246.822C204.52 263.347 204.028 273.45 202.35 279.012L202.736 279.133C202.959 278.389 203.145 277.635 203.292 276.872Z",
    fill: "#BEB8F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M238.514 255.073L238.426 254.68C238.358 254.696 238.173 254.722 237.886 254.766C217.053 257.937 209.993 265.037 207.639 268.986L207.985 269.193C210.303 265.3 217.277 258.311 237.947 255.165C238.249 255.119 238.443 255.088 238.514 255.073Z",
    fill: "#BEB8F2"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M250.312 31.0037C246.526 26.6891 241.443 24.1298 235.986 23.8099L75.4917 14.4058L75.2618 14.3936C62.0893 13.7453 51.1501 23.8257 51.0236 36.8753L48.5348 294.894C48.474 301.29 50.9677 307.106 55.5462 311.255C60.1053 315.391 66.1691 317.356 72.6064 316.82L233.52 303.414L233.717 303.397C244.87 302.357 253.934 291.888 254.032 280.055L256.071 46.6151C256.139 40.8798 254.088 35.3212 250.312 31.0037Z",
    fill: "url(#paint3_linear_5_256)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M235.984 303.414L75.066 316.82C68.6276 317.356 62.5638 315.386 58.0059 311.255C53.4273 307.106 50.9324 301.291 50.9945 294.894L53.4869 36.8753C53.6085 23.8257 64.5562 13.7441 77.7251 14.3936L77.9538 14.4058L238.448 23.8099C243.906 24.1298 248.99 26.6891 252.774 31.0037C256.551 35.3208 258.602 40.8794 258.536 46.6151L256.496 280.055C256.393 291.888 247.328 302.357 236.182 303.397L235.984 303.414Z",
    fill: "url(#paint4_linear_5_256)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M255.82 46.4874L254.786 164.837L253.775 280.25C253.683 290.615 245.766 299.656 236.006 300.456L75.0952 313.618C63.5576 314.564 54.1985 306.077 54.3104 294.653L55.5183 169.471L56.7943 37.0335C56.9038 25.6382 66.4125 16.9408 77.9234 17.5965L238.424 26.7609C248.16 27.318 255.91 36.1455 255.82 46.4874Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M255.303 164.843L254.293 280.217C254.201 290.578 246.289 299.614 236.534 300.409L75.7131 313.565C64.1815 314.509 54.8273 306.033 54.9405 294.613L56.1471 169.476L255.303 164.843Z",
    fill: "#D8DEE8"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M191.227 70.6891C191.068 88.3088 177.124 102.342 159.819 102.029C142.218 101.71 127.863 86.7128 128.032 68.5421C128.201 50.3714 142.822 36.3681 160.414 37.2439C177.708 38.1051 191.386 53.0718 191.227 70.6891Z",
    fill: "#D8DEE8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M237.435 121.635L76.1364 121.794V110.868L237.435 111.534V121.635Z",
    fill: "#D8DEE8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M214.577 141.279L101.583 142.493V131.269L214.577 130.654V141.279Z",
    fill: "#D8DEE8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M139.966 196.328C139.966 194.701 138.75 193.429 137.145 193.486L74.3094 195.742C72.6064 195.803 71.39 197.216 71.39 198.898V275.606C71.39 277.287 72.6417 278.546 74.3471 278.418L137.211 273.723C138.816 273.601 139.966 272.187 139.966 270.56V196.328Z",
    fill: "#D8DEE8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M120.835 219.379C120.835 228.055 113.822 235.476 105.108 235.959C96.3192 236.446 89.1411 229.706 89.1411 220.898C89.1411 212.089 96.3179 204.661 105.108 204.307C113.822 203.954 120.835 210.704 120.835 219.379Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M128.826 264.97C128.862 264.542 128.881 263.984 128.881 263.474C128.881 251.024 118.273 241.566 105.04 242.339C91.6359 243.123 80.6432 254.073 80.6432 266.811C80.6432 267.333 80.6627 267.906 80.6992 268.341L128.826 264.97Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M202.501 200.216L152.474 202.209V192.938L202.501 191.17V200.216Z",
    fill: "#D8DEE8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M241.747 213.532L152.474 217.801V208.53L241.747 204.665V213.532Z",
    fill: "#D8DEE8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M239.16 234.244L152.474 239.29V230.441L239.16 225.768V234.244Z",
    fill: "#D8DEE8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M239.16 247.968L152.474 253.617V244.346L239.16 239.088V247.968Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M133.015 234.857C137.43 179.171 170.798 155.244 168.626 106.619C167.587 83.3616 158.491 53.8527 127.484 18.9223L77.9246 16.0564C66.4149 15.3911 56.905 24.0848 56.7955 35.4764L54.3104 293.096C54.2009 304.518 63.5551 313.013 75.0964 312.072L144.787 306.421C136.045 285.069 130.941 261 133.015 234.857Z",
    fill: "#D8DEE8"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M179.056 273.935H175.869V269.913C175.867 269.285 175.638 268.679 175.224 268.208C174.81 267.736 174.239 267.431 173.617 267.349L159.723 265.542C159.359 265.495 158.988 265.525 158.636 265.632C158.284 265.74 157.959 265.921 157.683 266.163C157.407 266.406 157.185 266.705 157.034 267.04C156.882 267.375 156.804 267.739 156.804 268.106V271.807H153.617V268.106C153.617 267.285 153.792 266.474 154.13 265.726C154.469 264.978 154.963 264.311 155.58 263.769C156.197 263.227 156.922 262.823 157.707 262.584C158.493 262.345 159.32 262.276 160.134 262.382L174.033 264.192C175.422 264.376 176.697 265.057 177.622 266.109C178.546 267.162 179.058 268.514 179.061 269.915L179.056 273.935Z",
    fill: "#227750"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M127.048 272.415L143.968 269.346L142.434 336.402L129.941 334.353C129.401 334.265 128.908 333.994 128.543 333.586C128.179 333.178 127.966 332.658 127.939 332.111L125.086 274.888C125.057 274.308 125.24 273.737 125.601 273.282C125.962 272.827 126.476 272.519 127.048 272.415Z",
    fill: "url(#paint5_linear_5_256)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M200.564 277.678L196.672 326.231C196.604 327.028 196.268 327.779 195.718 328.359C195.167 328.94 194.436 329.316 193.644 329.427L142.433 336.402L143.968 269.346L147.569 269.652L197.365 273.9C198.29 273.979 199.145 274.421 199.745 275.129C200.344 275.837 200.639 276.754 200.564 277.678Z",
    fill: "url(#paint6_linear_5_256)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M135.044 270.965L133.462 271.252C133.736 283.189 134.602 321.125 134.896 335.165L136.495 335.427C136.199 321.497 135.315 282.801 135.044 270.965Z",
    fill: "#227750"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M196.589 326.741C196.428 327.434 196.06 328.063 195.534 328.542C195.008 329.022 194.348 329.33 193.643 329.427L142.432 336.402L143.967 269.346L147.568 269.652C150.932 272.253 154.874 277.122 155.671 285.864C157.108 301.677 159.502 300.377 171.521 302.893C183.541 305.41 182.097 311.795 182.67 320.382C183.098 326.784 191.288 325.511 196.589 326.741Z",
    fill: "url(#paint7_linear_5_256)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M142.807 180.257L134.372 184.383C134.229 184.452 134.102 184.55 133.999 184.671C133.896 184.792 133.819 184.933 133.773 185.085C133.727 185.237 133.714 185.397 133.733 185.555C133.752 185.713 133.804 185.865 133.886 186.001L141.538 199.445C141.613 199.584 141.717 199.706 141.842 199.801C141.968 199.897 142.112 199.966 142.266 200.001C142.42 200.037 142.58 200.04 142.735 200.009C142.89 199.978 143.037 199.915 143.166 199.823L150.904 194.471C151.373 194.149 151.5 193.453 151.194 192.915L144.283 180.777C143.968 180.244 143.31 180.008 142.807 180.257Z",
    fill: "url(#paint8_linear_5_256)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M143.034 180.125L134.6 184.251C134.457 184.32 134.33 184.418 134.227 184.539C134.124 184.66 134.047 184.801 134.001 184.953C133.955 185.105 133.942 185.265 133.961 185.422C133.98 185.58 134.032 185.732 134.113 185.869L141.767 199.312C141.842 199.451 141.945 199.573 142.071 199.668C142.196 199.764 142.341 199.832 142.495 199.868C142.649 199.904 142.808 199.906 142.963 199.875C143.118 199.845 143.265 199.781 143.393 199.689L151.133 194.337C151.601 194.015 151.728 193.319 151.423 192.781L144.51 180.649C144.201 180.111 143.544 179.875 143.034 180.125Z",
    fill: "url(#paint9_linear_5_256)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M144.769 185.967C145.665 187.54 145.214 189.519 143.72 190.412C142.18 191.333 140.128 190.752 139.181 189.088C138.233 187.424 138.794 185.383 140.386 184.555C141.931 183.752 143.873 184.394 144.769 185.967Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 186.232C145.018 187.527 144.653 189.152 143.419 189.882C142.157 190.626 140.486 190.145 139.713 188.787C138.941 187.428 139.392 185.765 140.686 185.083C141.955 184.42 143.551 184.942 144.288 186.232Z",
    fill: "white"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M148.287 192.145L142.902 195.624L142.229 194.442L147.65 191.027L148.287 192.145Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M148.87 193.172L143.519 196.71L143.184 196.12L148.553 192.614L148.87 193.172Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M143.999 194.006C142.546 190.995 143.512 188.792 141.944 186.337C141.191 185.162 139.841 183.893 137.211 182.973L134.6 184.251C134.457 184.32 134.33 184.418 134.227 184.539C134.124 184.66 134.047 184.801 134.001 184.953C133.955 185.105 133.942 185.265 133.961 185.422C133.98 185.58 134.032 185.732 134.113 185.869L141.767 199.312C141.842 199.451 141.945 199.573 142.071 199.668C142.196 199.764 142.341 199.832 142.495 199.868C142.649 199.904 142.808 199.906 142.963 199.875C143.118 199.845 143.265 199.781 143.393 199.689L146.753 197.37C145.588 196.475 144.646 195.324 143.999 194.006Z",
    fill: "url(#paint10_linear_5_256)"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M242.976 329.013C243.136 328.129 245.99 327.33 247.403 328.513C248.104 329.101 248.588 330.292 248.182 330.831C248.034 331.026 248.639 331.371 248.06 331.377C246.137 331.4 242.816 329.89 242.976 329.013Z",
    fill: "url(#paint11_linear_5_256)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M245.967 329.334L248.902 328.92C247.542 327.282 247.794 322.069 247.794 322.069L244.672 322.766C244.672 322.766 245.028 324.198 245.633 326.308C245.837 327.031 245.933 328.162 245.967 329.334Z",
    fill: "url(#paint12_linear_5_256)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M245.706 328.973C245.706 328.973 249.234 328.159 249.622 328.86C250.01 329.561 250.301 331.438 248.059 331.377C245.817 331.316 245.507 329.568 245.706 328.973Z",
    fill: "url(#paint13_linear_5_256)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M202.705 332.323C202.989 331.472 205.926 331.078 207.16 332.445C207.768 333.125 208.083 334.373 207.606 334.848C207.432 335.021 207.983 335.447 207.408 335.373C205.502 335.132 202.424 333.175 202.705 332.323Z",
    fill: "url(#paint14_linear_5_256)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M144.898 199.334L141.931 199.126C141.931 199.126 139.404 198.618 138.307 195.743C138.592 196.491 137.183 192.874 138.818 192.519L139.853 194.317C139.853 194.317 140.515 195.483 142.529 195.908C144.664 196.667 145.803 197.681 145.803 197.681L144.898 199.334Z",
    fill: "url(#paint15_linear_5_256)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M205.622 333.064H208.587C207.469 331.253 208.448 326.13 208.448 326.13L205.26 326.383C205.26 326.383 205.412 327.85 205.716 330.025C205.817 330.765 205.752 331.897 205.622 333.064Z",
    fill: "url(#paint16_linear_5_256)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M197.941 220.974C195.859 227.854 194.323 234.887 193.345 242.008C189.744 268.198 197.397 269.033 195.967 298.054C195.511 307.319 203.996 328.679 204.74 329.151C205.13 329.191 205.521 329.206 205.913 329.197C206.926 329.162 207.93 328.994 208.9 328.699C210.244 328.467 215.088 315.347 213.965 307.546C213.171 302.025 213.401 296.1 213.862 284.249C213.936 282.329 218.849 246.89 218.849 246.89C220.344 260.008 222.063 271.154 223.552 279.795C228.34 307.557 243.905 324.362 244.718 324.631C244.878 324.696 246.339 325.227 247.532 324.44C247.841 324.244 248.088 323.966 248.245 323.637C248.661 323.311 248.124 295.918 243.38 275.304C236.489 245.38 239.487 238.38 237.306 225.014C235.411 213.449 197.941 220.974 197.941 220.974Z",
    fill: "url(#paint17_linear_5_256)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M225.774 166.705C221.199 166.571 212.338 165.078 206.547 170.289C206.446 170.379 205.977 170.897 205.393 171.577C203.848 173.399 202.478 175.364 201.304 177.445C200.081 179.622 198.979 182.162 197.866 185.946C196.452 190.784 195.543 195.755 195.154 200.779C194.094 214.704 195.144 221.127 196.098 225.496C200.233 227.621 210.893 231.422 223.588 229.533C228.38 228.813 233.015 227.286 237.296 225.018C234.001 215.043 236.586 209.7 237.806 204.779C240.214 195.063 240.759 191.248 247.566 177.275C249.443 173.422 244.986 175.58 242.133 172.2C237.758 167.013 229.87 166.826 225.774 166.705Z",
    fill: "url(#paint18_linear_5_256)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M236.377 213.673C236.377 213.673 235.738 214.099 234.759 213.886C233.78 213.673 232.589 212.864 231.524 212.524C230.46 212.183 230.375 213.758 231.95 214.566C233.525 215.374 234.886 216.999 235.478 218.228C236.069 219.456 237.564 216.737 237.564 216.737L236.377 213.673Z",
    fill: "url(#paint19_linear_5_256)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M232.77 167.543C235.188 167.445 250.469 168.476 259.549 176.721C261.374 178.379 270.052 186.257 269.317 197.522C268.435 211.035 254.465 222.48 243.721 220.85C241.215 220.469 239.182 219.423 237.661 218.384L235.874 213.329C235.846 209.717 237.82 207.192 238.837 205.797C241.342 202.357 244.919 201.756 245.44 198.708C245.731 197.022 244.908 195.641 244.174 194.407C241.67 190.205 237.673 189.687 235.604 187.537C233.468 185.32 226.739 178.541 232.77 167.543Z",
    fill: "url(#paint20_linear_5_256)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M205.415 332.67C205.415 332.67 209.028 332.358 209.308 333.105C209.588 333.852 209.619 335.752 207.408 335.379C205.196 335.005 205.134 333.229 205.415 332.67Z",
    fill: "url(#paint21_linear_5_256)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M213.669 168.374C208.664 165.119 195.579 175.32 191.619 178.132C176.258 189.042 174.068 201.911 166.33 201.304C161.099 200.894 157.968 194.685 149.513 195.214C148.339 195.288 147.176 195.481 146.042 195.792C146.035 195.802 144.084 198.085 144.074 198.092C143.31 198.721 142.545 199.349 142.107 200.392C141.947 202.444 142.092 204.508 142.535 206.517C143.012 207.71 143.669 208.823 144.482 209.817C147.258 213.15 158.105 220.378 171.064 217.499C173.232 217.012 174.286 216.514 182.9 211.892C205.868 199.571 207.79 198.103 209.682 195.2C215.012 187.027 218.499 171.514 213.669 168.374Z",
    fill: "url(#paint22_linear_5_256)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M212.899 161.46C211.482 159.064 212.113 156.327 212.255 155.736C212.851 153.259 213.073 152.884 213.532 152.36L214.182 151.673C214.182 151.673 214.222 151.642 214.266 151.613C214.717 151.302 216.404 150.797 216.769 150.779C217.932 150.72 220.297 154.893 221.657 161.324C221.766 161.554 221.876 161.785 221.984 162.02C222.657 163.479 223.233 164.913 223.728 166.312C231.592 166.976 232.684 167.894 232.719 168.433C232.793 169.554 228.312 170.85 224.942 171.343C217.593 172.419 210.039 170.481 210.074 169.111C210.089 168.514 211.55 167.737 217.779 166.922C217.633 165.891 217.487 164.86 217.342 163.83C216.836 163.715 213.942 163.225 212.899 161.46Z",
    fill: "url(#paint23_linear_5_256)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M212.337 150.835C212.149 152.228 213.006 153.725 213.997 154.511C214.589 154.981 214.819 154.901 215.092 155.301C215.852 156.424 214.272 158.407 214.8 158.859C215.177 159.183 216.078 158.251 216.624 158.598C217.233 158.977 216.471 160.301 217.031 162.004C217.058 162.085 217.073 162.125 217.079 162.147C217.444 163.094 218.417 163.529 218.68 163.645C219.921 164.198 221.742 163.803 222.878 162.754C223.453 162.224 223.513 161.841 224.486 159.037C225.731 155.453 225.872 155.445 225.889 154.741C225.9 154.321 225.924 151.804 224.127 149.717C221.766 146.974 217.486 146.402 214.732 147.93C214.288 148.166 212.568 149.121 212.337 150.835Z",
    fill: "#26264F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M215.381 158.204C215.685 157.413 216.698 157.81 216.931 158.664C217.165 159.517 216.572 160.629 215.722 160.675C214.872 160.722 214.97 159.267 215.381 158.204Z",
    fill: "url(#paint24_linear_5_256)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M195.073 205.607C195.035 205.607 194.998 205.594 194.968 205.57C194.939 205.545 194.918 205.511 194.911 205.473C194.904 205.436 194.911 205.397 194.929 205.363C194.948 205.329 194.978 205.304 195.014 205.29C195.086 205.262 202.171 202.486 208.777 195.965C208.808 195.934 208.85 195.917 208.894 195.917C208.937 195.917 208.979 195.935 209.01 195.966C209.04 195.997 209.058 196.039 209.057 196.082C209.057 196.126 209.04 196.168 209.009 196.198C202.351 202.767 195.204 205.565 195.132 205.596C195.113 205.603 195.093 205.607 195.073 205.607Z",
    fill: "#9B305E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M237.615 196.35L230.31 199.924C230.186 199.984 230.076 200.068 229.986 200.173C229.897 200.277 229.83 200.399 229.789 200.531C229.749 200.663 229.737 200.802 229.754 200.938C229.77 201.075 229.815 201.207 229.885 201.325L236.513 212.969C236.578 213.089 236.668 213.194 236.777 213.277C236.886 213.36 237.011 213.419 237.144 213.45C237.277 213.481 237.416 213.483 237.55 213.457C237.684 213.43 237.811 213.376 237.923 213.296L244.625 208.665C245.03 208.386 245.141 207.783 244.876 207.318L238.891 196.804C238.626 196.338 238.052 196.135 237.615 196.35Z",
    fill: "url(#paint25_linear_5_256)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M237.818 196.236L230.51 199.809C230.386 199.868 230.275 199.953 230.186 200.057C230.096 200.162 230.029 200.284 229.989 200.416C229.949 200.547 229.937 200.686 229.953 200.823C229.969 200.96 230.014 201.091 230.084 201.21L236.712 212.853C236.777 212.974 236.867 213.079 236.976 213.162C237.085 213.245 237.21 213.304 237.343 213.335C237.477 213.366 237.615 213.368 237.749 213.341C237.884 213.315 238.011 213.26 238.122 213.181L244.826 208.55C245.23 208.27 245.34 207.668 245.069 207.203L239.084 196.69C238.828 196.224 238.258 196.019 237.818 196.236Z",
    fill: "url(#paint26_linear_5_256)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M239.32 201.295C240.096 202.657 239.705 204.373 238.412 205.145C237.074 205.943 235.3 205.439 234.48 203.999C233.66 202.559 234.145 200.79 235.524 200.073C236.862 199.377 238.544 199.933 239.32 201.295Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M238.903 201.529C239.542 202.649 239.214 204.056 238.15 204.691C237.055 205.337 235.61 204.92 234.941 203.747C234.272 202.575 234.664 201.131 235.793 200.538C236.88 199.956 238.266 200.407 238.903 201.529Z",
    fill: "white"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.366 206.646L237.703 209.659L237.12 208.636L241.815 205.679L242.366 206.646Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.872 207.535L238.238 210.601L237.947 210.089L242.597 207.052L242.872 207.535Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M238.66 208.259C237.401 205.65 238.241 203.742 236.879 201.615C236.227 200.598 235.054 199.5 232.781 198.703L230.518 199.809C230.394 199.868 230.284 199.953 230.194 200.057C230.104 200.162 230.037 200.284 229.997 200.416C229.957 200.547 229.945 200.686 229.962 200.823C229.978 200.96 230.023 201.091 230.093 201.21L236.721 212.853C236.786 212.974 236.876 213.079 236.985 213.162C237.093 213.245 237.219 213.304 237.352 213.335C237.485 213.366 237.624 213.368 237.758 213.341C237.892 213.315 238.019 213.26 238.131 213.181L241.04 211.171C240.033 210.397 239.219 209.4 238.66 208.259Z",
    fill: "url(#paint27_linear_5_256)"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M290.693 328.665C291.643 330.18 291.495 330.889 291.332 331.21C290.852 332.155 289.385 331.463 285.847 332.264C285.118 332.453 284.36 332.506 283.612 332.418C282.733 332.306 281.673 331.955 281.692 331.72C281.699 331.635 281.848 331.585 281.904 331.567C282.878 331.25 288.912 328.686 288.912 328.686L290.693 328.665Z",
    fill: "url(#paint28_linear_5_256)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M290.805 325.109L290.621 328.734C290.621 328.734 289.203 329.977 288.663 328.704C288.274 327.788 288.016 325.239 288.016 325.239L290.805 325.109Z",
    fill: "#D8DEE8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M272.898 328.765L274.831 332.715L276.98 332.138L276.077 328.388L272.898 328.765Z",
    fill: "#D8DEE8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M275.748 334.906C276.675 333.54 277.632 333.555 277.732 332.672C277.811 331.979 277.309 331.191 276.649 330.94C275.724 330.589 274.73 331.393 274.505 331.575C272.98 332.81 273.599 334.426 272.132 335.309C271.836 335.487 271.361 335.693 270.892 336.233C270.694 336.463 270.201 337.031 270.365 337.369C270.556 337.762 271.527 337.645 272.452 337.535C273.56 337.403 274.113 337.337 274.612 336.949C275.304 336.409 275.03 335.96 275.748 334.906Z",
    fill: "url(#paint29_linear_5_256)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M293.583 238.562C293.991 245.723 293.746 252.907 292.853 260.023C292.049 266.386 291.368 267.531 291.315 271.889C291.193 281.377 294.341 282.472 295.779 293.055C297.367 304.748 295.019 314.342 294.086 318.004C293.426 320.591 292.614 323.137 291.653 325.628C290.654 326.656 288.977 326.432 287.213 326.223C285.69 315.623 284.062 305.665 282.539 295.066C279.15 279.211 275.759 263.357 272.368 247.504L293.583 238.562Z",
    fill: "url(#paint30_linear_5_256)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M287.212 326.228C285.689 315.628 284.061 305.67 282.538 295.071C279.148 279.216 275.758 263.362 272.367 247.509L293.583 238.562C293.614 239.114 293.629 239.648 293.653 240.191C284.188 249.893 282.773 257.075 283.27 261.852C283.871 267.647 287.285 270.261 287.361 278.728C287.417 284.782 285.696 285.992 286.145 291.423C286.725 298.414 290.052 302.097 291.849 306.019C293.584 309.807 294.545 315.297 292.469 323.39C292.178 324.232 291.9 324.987 291.649 325.637C290.653 326.661 288.977 326.437 287.212 326.228Z",
    fill: "url(#paint31_linear_5_256)"
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M281.376 247.644C276.78 257.111 274.4 264.46 273.152 268.98C272.391 271.736 271.731 274.597 271.826 278.269C271.931 281.847 272.704 285.373 274.106 288.666C275.659 291.966 276.881 295.411 277.755 298.951C280.89 311.677 278.764 322.72 276.916 329.118L273.158 330.874C268.274 320.1 264.289 308.939 261.246 297.507C259.193 289.802 257.61 283.762 256.953 275.966C256.261 267.748 256.354 254.652 261.79 238.562L281.376 247.644Z",
    fill: "url(#paint32_linear_5_256)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M272.494 176.744C264.395 178.836 258.262 180.824 255.829 185.358C253.257 190.148 258.229 193.18 260.33 203.047C263.548 218.151 255.243 224.577 259.043 239.745C260.049 243.718 261.663 247.512 263.826 250.994C266.66 252.94 271.125 255.545 277.016 257.076C285.589 259.3 289.558 257.265 300.82 256.976C319.24 256.504 322.425 261.599 330.437 257.638C338.534 253.64 343.854 244.208 341.762 240.539C340.509 238.342 337.273 240.052 332.23 237.64C325.73 234.538 326.363 229.517 320.982 225.701C313.253 220.219 306.81 226.936 300.193 222.16C293.503 217.33 291.678 204.385 293.689 196.422C295.005 191.221 294.582 185.718 295.439 180.421C295.547 179.781 295.465 179.124 295.206 178.529C293.933 175.631 288.429 175.511 284.27 175.459C277.927 175.381 273.16 176.576 272.494 176.744Z",
    fill: "url(#paint33_linear_5_256)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M328.993 251.929C326.317 250.448 327.29 245.54 323.321 243.305C319.636 241.237 317.171 244.547 311.897 243.397C305.134 241.922 304.953 235.543 298.465 234.04C293.798 232.959 292.667 235.974 286.122 236.643C279.576 237.312 270.784 235.32 264.776 228.833C262.491 226.349 260.77 223.401 259.73 220.19C258.448 225.988 257.001 231.612 259.041 239.749C260.047 243.723 261.66 247.517 263.824 250.999C266.658 252.945 271.122 255.549 277.013 257.081C285.585 259.304 289.556 257.269 300.817 256.981C319.237 256.509 322.423 261.603 330.434 257.643C335.61 255.088 339.638 250.316 341.335 246.245C334.525 252.113 330.937 253.005 328.993 251.929Z",
    fill: "url(#paint34_linear_5_256)"
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M266.569 162.923C266.569 162.923 264.658 167.362 264.763 170.356C264.867 173.349 268.219 172.852 268.219 172.852L268.249 174.743C268.261 175.533 268.043 176.31 267.623 176.979C267.203 177.648 266.598 178.181 265.882 178.514L264.594 179.113C264.594 179.113 273.416 180.25 277.872 176.513L276.49 176.501C275.546 176.487 274.635 176.146 273.913 175.537C273.191 174.928 272.702 174.088 272.528 173.16L272.38 172.362C272.38 172.362 273.116 162.939 266.569 162.923Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M236.38 212.173C236.38 212.173 233.117 210.419 232.609 208.995C232.102 207.571 231.903 204.812 231.903 204.812L234.085 208.5C234.085 208.5 234.917 208.164 235.153 206.849C235.389 205.534 236.137 206.638 235.985 207.628C235.833 208.618 236.38 212.173 236.38 212.173Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M257.133 183.77C254.904 185.451 253.002 187.527 251.523 189.895C246.247 198.433 249.505 206.602 244.767 210.107C243.414 211.109 240.95 212.065 236.206 210.925L234.55 212.041C234.55 212.041 233.546 223.161 246.82 222.184C260.093 221.208 264.965 204.073 264.965 204.073L257.133 183.77Z",
    fill: "url(#paint35_linear_5_256)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M268.275 167.039C268.72 166.964 269.042 166.365 269.363 166.508C269.684 166.652 269.728 167.49 269.501 168.09C269.35 168.467 269.093 168.793 268.761 169.029C269.296 169.641 269.69 170.363 269.913 171.145C270.498 173.265 269.496 175.094 269.104 176.147C267.335 180.891 271.275 187.846 275.243 191.192C278.468 193.911 279.76 192.604 281.739 194.879C285.591 199.307 281.243 204.887 283.564 211.086C287.091 220.511 302.563 222.119 303.204 222.177C303.457 222.202 303.626 222.215 303.889 222.234C310.815 222.754 321.312 223.541 328.144 217.325C333.253 212.675 335.154 205.161 334.208 198.759C333.958 197.075 332.912 190.692 327.242 185.881C326.342 185.118 321.013 180.608 314.358 181.099C310.831 181.359 310.222 182.66 307.468 182.116C303.698 181.37 301.143 178.206 299.562 176.243C296.653 172.633 297.639 171.728 295.618 170.001C291.658 166.618 287.611 169.868 283.438 166.938C279.324 164.05 281.285 159.508 277.342 157.04C273.273 154.495 266.029 156.102 264.748 159.64C263.645 162.685 266.91 167.265 268.275 167.039Z",
    fill: "url(#paint36_linear_5_256)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M125.425 201.569C125.425 201.569 126.006 199.258 128.407 197.32C130.808 195.382 135.161 199.438 135.503 200.604C135.845 201.771 134.243 201.42 133.282 201.512C132.321 201.603 130.69 205.312 128.216 205.501C125.742 205.691 125.425 201.569 125.425 201.569Z",
    fill: "url(#paint37_linear_5_256)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7964 173.552C89.5899 166.286 83.8411 160.573 76.4526 158.811C73.0929 158.01 69.7624 157.988 67.3563 159.735C67.3563 159.735 69.0009 188.101 87.0829 199.351C105.165 210.602 127.17 206.219 127.17 206.219L125.588 197.583C125.588 197.583 100.337 201.671 91.7964 173.552Z",
    fill: "url(#paint38_linear_5_256)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8415 158.346L73.6124 155.812C72.5796 155.447 71.5943 156.124 71.4228 157.254L71.4131 157.311C71.2392 158.441 71.9337 159.651 72.9652 160.013L80.1956 162.548C81.2271 162.912 82.2063 162.286 82.3851 161.155L82.3936 161.099C82.5615 159.968 81.8742 158.709 80.8415 158.346Z",
    fill: "url(#paint39_linear_5_256)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1314 228.971C23.1314 228.971 25.6749 229.875 27.6005 232.788C29.526 235.701 24.4889 240.175 23.1314 240.434C21.7739 240.693 22.3456 238.926 22.3456 237.834C22.3456 236.741 18.3399 234.504 18.3922 231.694C18.4445 228.884 23.1314 228.971 23.1314 228.971Z",
    fill: "url(#paint40_linear_5_256)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2853 323.272C59.0361 325.09 58.9084 326.382 58.9814 327.011C59.103 328.027 59.8633 328.42 61.694 330.336C64.1706 332.926 63.7923 333.274 65.0525 334.211C67.8369 336.279 71.7732 336.143 72.0104 335.438C72.177 334.945 70.3962 334.542 68.3709 332.197C67.1227 330.769 66.2085 329.081 65.6948 327.256C65.4477 326.336 65.3125 325.389 65.2921 324.437L61.2853 323.272Z",
    fill: "url(#paint41_linear_5_256)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8185 317.732L64.3896 325.45C63.3228 325.922 62.3022 325.684 61.3571 324.308L63.0856 314.928L68.8185 317.732Z",
    fill: "url(#paint42_linear_5_256)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M74.189 218.732C78.5036 226.017 85.5016 240.077 86.9199 259.088C88.3176 277.853 83.5845 292.155 81.6018 297.488C77.8869 307.48 71.4253 317.974 67.6727 322.975C65.1413 321.917 63.6512 320.256 61.1199 319.198C61.4994 317.821 62.6732 313.272 63.4116 310.562C63.9845 308.463 65.0403 304.579 65.2569 303.75C67.0742 296.799 65.64 291.586 66.14 282.989C66.7226 272.965 69.0204 274.129 68.675 268.111C68.1592 259.124 63.0661 257.027 57.2213 244.019C53.2193 235.117 49.0214 225.766 52.8799 220.657C57.7407 214.217 72.5371 218.263 74.189 218.732Z",
    fill: "url(#paint43_linear_5_256)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9613 330.332C41.6123 331.183 40.7985 333.229 41.4128 334.514C42.021 335.777 43.5573 335.378 47.299 336.527C51.3059 337.758 52.099 339.002 55.0536 339C56.2469 339 58.4097 338.793 58.591 337.992C58.7126 337.427 57.7991 336.865 54.7751 334.829C50.4811 331.945 50.5262 331.865 49.5676 331.423C47.1603 330.315 44.7433 329.198 42.9613 330.332Z",
    fill: "url(#paint44_linear_5_256)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3718 324.218L47.7272 331.732C47.4973 332.068 45.1545 332.872 43.5135 331.732L44.1218 324.218H49.3718Z",
    fill: "url(#paint45_linear_5_256)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M52.8799 220.657C57.7456 214.221 72.5371 218.266 74.189 218.736C76.5207 222.682 78.5604 226.794 80.2917 231.038C75.049 230.007 72.7719 230.943 71.7124 232.187C67.5948 237.014 80.4839 247.672 77.8334 263.844C76.797 270.169 74.0917 273.016 74.5868 280.741C74.9517 286.49 76.741 289.401 77.9757 293.61C78.8588 296.659 79.3092 299.818 79.3137 302.993C75.6061 311.143 70.7344 318.893 67.669 322.979C65.1377 321.92 63.6476 320.26 61.1162 319.202C61.4957 317.825 62.6696 313.275 63.4079 310.565C63.9809 308.467 65.0367 304.583 65.2532 303.753C67.0706 296.803 65.6364 291.589 66.1364 282.993C66.719 272.968 69.0168 274.132 68.6713 268.115C68.1556 259.128 63.0625 257.031 57.2176 244.023C53.2193 235.117 49.0215 225.766 52.8799 220.657Z",
    fill: "url(#paint46_linear_5_256)"
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6355 222.654C63.1072 241.904 62.1346 261.162 59.7258 280.267C57.7288 296.093 54.7481 311.779 50.801 327.234C50.3144 327.515 48.6042 328.418 46.4134 327.995C45.2763 327.769 44.2221 327.238 43.3639 326.459C43.9182 322.404 44.0706 318.304 43.8188 314.219C43.2702 305.358 41.2266 303.553 40.3496 294.383C39.5808 286.342 40.391 279.772 40.7839 276.726C41.993 267.35 43.6351 267.158 43.668 261.543C43.7178 252.896 39.8448 249.801 37.7161 241.562C36.2965 236.067 35.5424 227.863 39.1137 216.612L62.6355 222.654Z",
    fill: "url(#paint47_linear_5_256)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M39.1101 216.612L45.9974 218.381C44.7969 222.603 43.6437 228.94 45.0304 236.133C46.9438 246.067 51.891 248.247 52.6184 257.205C53.2728 265.264 49.5457 266.907 47.7612 277.655C45.9366 288.671 48.7003 293.852 49.2793 303.064C49.6759 309.369 49.036 317.618 45.2749 327.657C44.5719 327.372 43.924 326.966 43.3603 326.459C43.9146 322.404 44.067 318.304 43.8152 314.219C43.2666 305.358 41.223 303.553 40.346 294.383C39.5772 286.342 40.3874 279.772 40.7803 276.726C41.9894 267.35 43.6315 267.158 43.6644 261.543C43.7142 252.896 39.8412 249.801 37.7125 241.562C36.2929 236.067 35.5388 227.863 39.1101 216.612Z",
    fill: "url(#paint48_linear_5_256)"
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2744 195.72C80.5533 208.06 81.0362 225.504 84.3825 233.388C84.5225 233.692 84.5748 234.029 84.5334 234.361C84.2901 236.176 80.9754 237.435 76.1401 238.146L76.0331 238.16C75.864 238.185 75.6925 238.212 75.5198 238.233C75.347 238.253 75.1621 238.28 74.9809 238.302C73.8861 238.441 72.7208 238.545 71.5129 238.634L71.0908 238.66C65.398 239.024 58.6737 238.841 52.5588 238.112C50.2038 237.836 47.9438 237.474 45.8613 237.034C45.8004 237.021 45.7396 237.013 45.6751 236.995C39.435 235.657 34.8722 233.597 34.5316 230.84C35.4467 228.318 36.2283 225.748 36.8732 223.143C38.0981 219.934 39.396 215.677 39.879 208.237C39.9653 206.914 39.9045 205.75 39.9045 204.667V204.65C40.3363 198.227 38.783 195.247 37.6444 185.203C37.5544 184.439 37.4851 183.638 37.4011 182.789C37.3488 182.266 37.3099 181.753 37.2673 181.244C36.6271 174.16 36.4414 167.042 36.7114 159.935C46.8602 155.434 58.1065 154.009 69.057 155.838C71.664 156.811 74.0594 158.276 76.1122 160.155C78.3139 161.993 80.2233 164.155 81.7746 166.568C86.5575 174.007 86.3762 181.486 86.2996 183.568C86.1123 188.665 84.7584 188.995 83.2744 195.72Z",
    fill: "url(#paint49_linear_5_256)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1474 238.186C75.9454 238.217 75.7386 238.247 75.527 238.268C75.3506 238.295 75.1694 238.312 74.9881 238.332C73.8933 238.454 72.7365 238.557 71.5201 238.63L71.098 238.656C65.4648 238.971 58.7198 238.778 52.566 238.109C50.2111 237.832 47.951 237.47 45.8685 237.031C45.8076 237.017 45.7468 237.009 45.6824 236.992C39.4422 235.654 34.8794 233.593 34.5388 230.837C35.4539 228.314 36.2355 225.745 36.8804 223.139C38.1053 219.93 39.4032 215.673 39.8862 208.233C39.9725 206.91 39.9117 205.746 39.9117 204.663V204.646C40.3435 198.224 38.7902 195.243 37.6516 185.2C40.5455 185.255 45.9232 186.051 48.0884 186.76C53.5221 188.543 61.1977 198.185 61.6806 204.581C62.4226 214.406 46.7187 219.797 48.811 226.68C49.3802 228.56 51.183 230.251 62.9529 234.205C67.6617 235.786 72.0529 237.087 76.0379 238.156C76.0737 238.168 76.1102 238.179 76.1474 238.186Z",
    fill: "url(#paint50_linear_5_256)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7235 159.929C36.7235 159.929 11.3529 172.722 8.22425 193.786C5.09564 214.851 17.8704 233.296 17.8704 233.296L25.1688 228.408C25.1688 228.408 8.74609 202.775 40.8131 182.742C40.8131 182.742 44.3662 164.449 36.7235 159.929Z",
    fill: "url(#paint51_linear_5_256)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M73.554 176.471C73.3545 179.39 72.8899 181.896 72.1479 183.404C70.6882 181.823 68.8636 179.755 66.8905 177.479C59.0666 168.478 48.794 156.121 48.794 156.121C53.3872 154.474 64.9723 152.827 69.4523 155.967C72.7038 158.24 74.0795 168.763 73.554 176.471Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7358 157.138C68.706 157.08 68.6646 157.029 68.6141 156.987L68.5983 156.976C67.9001 156.368 64.9904 155.721 64.235 153.935C63.8798 153.094 63.9054 151.77 65.348 149.61C64.3749 147.782 63.399 145.954 62.4202 144.125C61.9749 150.157 60.1467 153.51 58.5556 154.248C57.057 154.944 56.1289 154.248 52.9601 155.562C52.167 155.891 51.9992 156.535 52.0503 156.993C52.0537 157.033 52.064 157.071 52.0807 157.107C52.1664 157.364 52.3451 157.581 52.5818 157.715C53.6352 158.642 56.776 160.401 66.1643 162.658C67.7541 159.881 69.4315 158.175 68.7358 157.138Z",
    fill: "url(#paint52_linear_5_256)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9924 145.604C71.3414 144.346 71.8535 141.909 70.8755 140.196C70.0337 138.722 68.3612 138.307 67.3601 138.059C64.4601 137.339 60.508 138.038 58.7309 140.492C57.6787 141.951 58.7552 145.403 58.9097 146.02C59.0848 146.717 59.5799 147.014 59.9838 147.576C60.5445 148.357 61.4203 149.595 62.8399 151.662C63.1279 151.017 63.471 150.398 63.8653 149.812C64.3849 149.042 64.9978 148.339 65.6899 147.719C67.5583 146.115 68.7152 146.799 69.9924 145.604Z",
    fill: "url(#paint53_linear_5_256)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6186 149.796C60.6186 149.796 62.0041 153.134 65.9234 153.401C69.4315 153.645 71.3048 146.201 69.3792 144.316C68.737 143.687 67.2967 143.271 66.0329 143.438C65.2872 143.536 64.9953 143.789 63.774 143.924C62.6476 144.046 62.3642 143.896 61.9907 144.118C61.5236 144.395 61.0784 145.165 61.3582 147.449C60.8145 146.72 60.0652 146.362 59.4557 146.544C59.2458 146.619 59.0591 146.748 58.9144 146.918C58.2734 147.715 58.8865 148.918 60.6186 149.796Z",
    fill: "url(#paint54_linear_5_256)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9154 143.658C62.0601 143.8 61.4397 144.335 61.2463 145.182C60.8717 146.828 62.2462 149.042 63.9857 149.439C65.0148 149.683 65.4138 149.106 67.1763 149.157C68.0289 149.184 68.872 149.344 69.6748 149.632C69.8889 151.517 69.0472 153.259 67.6386 153.933C66.1205 154.663 64.4917 153.882 63.8105 153.558C63.3544 153.341 61.8935 152.648 61.3339 151.17C60.75 149.63 61.7341 148.879 60.9422 147.784C60.5432 147.233 59.9399 146.932 59.4825 145.911C59.3829 145.69 59.3015 145.462 59.2393 145.228C60.3121 144.43 61.7049 143.445 61.9154 143.658Z",
    fill: "url(#paint55_linear_5_256)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3744 143.624C58.3744 143.624 53.0635 139.301 56.8368 137.873C60.6101 136.445 63.6293 133.41 67.4573 135.124C71.2854 136.838 75.274 139.051 74.4651 140.301C73.6561 141.55 71.3827 143.477 71.3827 143.477C71.3827 143.477 66.8649 141.59 58.3744 143.624Z",
    fill: "url(#paint56_linear_5_256)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8206 143.123C60.8206 143.123 63.5953 146.656 68.214 146.568C72.8327 146.479 73.1356 146.19 71.3839 143.477C67.4574 142.381 64.8202 141.692 60.8206 143.123Z",
    fill: "url(#paint57_linear_5_256)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1478 142.865C72.1393 142.667 70.8536 141.206 67.2822 141.212C64.2898 141.212 59.9363 141.446 59.9509 142.524C59.9655 143.602 60.7039 143.283 60.9423 143.263C61.1807 143.242 68.3782 141.895 71.3876 143.477C71.3827 143.477 72.1685 143.377 72.1478 142.865Z",
    fill: "url(#paint58_linear_5_256)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8976 137.34C67.6532 137.364 67.36 136.679 67.36 136.679C67.36 136.679 67.0608 137.364 65.8164 137.34C65.8347 137.98 65.8395 138.592 65.8383 139.11C65.8383 139.307 65.8777 139.503 65.9541 139.685C66.0306 139.867 66.1425 140.032 66.2835 140.17C66.5707 140.453 66.9573 140.611 67.36 140.611C67.7605 140.605 68.144 140.448 68.4329 140.17C68.573 140.032 68.6841 139.867 68.7595 139.684C68.8349 139.502 68.8731 139.307 68.872 139.11C68.8708 138.592 68.8793 137.98 68.8976 137.34Z",
    fill: "url(#paint59_linear_5_256)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M73.554 176.471C73.3545 179.39 72.8898 181.896 72.1478 183.404C70.6881 181.823 68.8635 179.755 66.8905 177.479L65.443 165.158C65.443 165.158 65.1717 161.742 67.5109 164.718C69.0557 166.676 71.8328 172.628 73.554 176.471Z",
    fill: "url(#paint60_linear_5_256)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5053 161.982L63.3739 163.327L65.4357 165.157L67.5109 164.719L67.8758 162.488L66.8613 161.499L63.5053 161.982Z",
    fill: "url(#paint61_linear_5_256)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7329 156.358C50.5577 155.228 49.5724 154.555 48.5433 154.917L41.3142 157.451C40.2815 157.816 39.5942 159.073 39.7694 160.204L39.7779 160.259C39.9531 161.391 40.9323 162.014 41.9674 161.652L49.1978 159.117C50.2293 158.752 50.9239 157.546 50.7487 156.416L50.7329 156.358Z",
    fill: "url(#paint62_linear_5_256)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_256",
    x1: 14.9687,
    y1: 113.923,
    x2: 97.3536,
    y2: 189.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DF5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32B77A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_256",
    x1: 289.822,
    y1: 51.1072,
    x2: 239.612,
    y2: 133.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B77A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DF5B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_256",
    x1: 189.334,
    y1: 327.931,
    x2: 96.5721,
    y2: 524.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C9E6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_256",
    x1: 48.53,
    y1: 165.635,
    x2: 256.075,
    y2: 165.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_256",
    x1: 368.16,
    y1: 226.938,
    x2: -25.9009,
    y2: 122.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_256",
    x1: 122.755,
    y1: 307.74,
    x2: 180.704,
    y2: 291.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B77A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DF5B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_256",
    x1: 142.433,
    y1: 302.874,
    x2: 200.576,
    y2: 302.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B77A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87FFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_256",
    x1: 142.433,
    y1: 302.874,
    x2: 196.589,
    y2: 302.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6165D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA80F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_256",
    x1: 155.101,
    y1: 186.732,
    x2: 132.506,
    y2: 192.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_256",
    x1: 155.335,
    y1: 186.599,
    x2: 132.74,
    y2: 192.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5_256",
    x1: 156.581,
    y1: 186.892,
    x2: 132.736,
    y2: 193.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5_256",
    x1: 241.392,
    y1: 326.436,
    x2: 247.675,
    y2: 330.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5_256",
    x1: 247.477,
    y1: 330.656,
    x2: 246.102,
    y2: 320.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5_256",
    x1: 241.864,
    y1: 325.727,
    x2: 248.147,
    y2: 329.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5_256",
    x1: 201.494,
    y1: 329.58,
    x2: 207.13,
    y2: 334.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5_256",
    x1: 138.231,
    y1: 194.616,
    x2: 145.413,
    y2: 197.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5_256",
    x1: 206.924,
    y1: 334.604,
    x2: 206.924,
    y2: 324.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5_256",
    x1: 207.321,
    y1: 289.036,
    x2: 244.057,
    y2: 250.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D2F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5_256",
    x1: 220.539,
    y1: 105.301,
    x2: 221.833,
    y2: 244.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B77A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C9E6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5_256",
    x1: 236.474,
    y1: 205.619,
    x2: 229.408,
    y2: 233.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5_256",
    x1: 249.083,
    y1: 105.034,
    x2: 250.377,
    y2: 243.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DF5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#227750"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5_256",
    x1: 202.06,
    y1: 328.943,
    x2: 207.697,
    y2: 333.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5_256",
    x1: 178.235,
    y1: 105.695,
    x2: 179.529,
    y2: 244.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C9E6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32B77A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5_256",
    x1: 220.743,
    y1: 155.611,
    x2: 222.998,
    y2: 175.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5_256",
    x1: 214.481,
    y1: 155.162,
    x2: 220.11,
    y2: 170.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5_256",
    x1: 248.265,
    y1: 201.954,
    x2: 228.696,
    y2: 207.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5_256",
    x1: 248.466,
    y1: 201.839,
    x2: 228.898,
    y2: 207.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5_256",
    x1: 249.546,
    y1: 202.094,
    x2: 228.895,
    y2: 207.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5_256",
    x1: 285.089,
    y1: 340.289,
    x2: 289.658,
    y2: 314.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5_256",
    x1: 273.598,
    y1: 338.272,
    x2: 278.165,
    y2: 312.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5_256",
    x1: 284,
    y1: 247.212,
    x2: 297.797,
    y2: 330.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E432B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D2118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5_256",
    x1: 284,
    y1: 247.212,
    x2: 297.797,
    y2: 330.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5_256",
    x1: 231.864,
    y1: 289.483,
    x2: 299.355,
    y2: 278.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C9E6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5_256",
    x1: 334.462,
    y1: 295.09,
    x2: 273.876,
    y2: 198.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C9E6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_5_256",
    x1: 248.087,
    y1: 189.632,
    x2: 306.967,
    y2: 253.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_5_256",
    x1: 314.089,
    y1: 307.813,
    x2: 253.505,
    y2: 210.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C9E6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32B77A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_5_256",
    x1: 320.606,
    y1: 221.099,
    x2: 276.42,
    y2: 150.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5_256",
    x1: 126.234,
    y1: 200.295,
    x2: 146.718,
    y2: 206.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_5_256",
    x1: 72.3356,
    y1: 187.472,
    x2: 121.779,
    y2: 177.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5_256",
    x1: 71.3827,
    y1: 159.182,
    x2: 82.4131,
    y2: 159.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_5_256",
    x1: 24.4609,
    y1: 230.088,
    x2: 15.2527,
    y2: 252.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5_256",
    x1: 72.8208,
    y1: 330.028,
    x2: 60.1787,
    y2: 330.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_5_256",
    x1: 62.2386,
    y1: 315.398,
    x2: 69.1704,
    y2: 326.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5_256",
    x1: 86.6082,
    y1: 327.74,
    x2: 59.3733,
    y2: 231.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_5_256",
    x1: 58.6031,
    y1: 334.429,
    x2: 41.2048,
    y2: 334.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5_256",
    x1: 49.1346,
    y1: 333.546,
    x2: 42.4298,
    y2: 319.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_5_256",
    x1: 86.3027,
    y1: 327.826,
    x2: 59.0678,
    y2: 231.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5_256",
    x1: 59.6321,
    y1: 285.015,
    x2: 20.1754,
    y2: 222.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5_256",
    x1: 54.6887,
    y1: 288.199,
    x2: 15.2089,
    y2: 225.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5_256",
    x1: 34.5365,
    y1: 196.95,
    x2: 86.3312,
    y2: 196.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5_256",
    x1: 19.7047,
    y1: 108.174,
    x2: 55.7408,
    y2: 235.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5_256",
    x1: 31.0721,
    y1: 168.824,
    x2: 15.9764,
    y2: 212.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5_256",
    x1: 55.3869,
    y1: 171.11,
    x2: 65.3663,
    y2: 143.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5_256",
    x1: 54.7463,
    y1: 160.219,
    x2: 66.7436,
    y2: 139.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_5_256",
    x1: 64.6579,
    y1: 144.93,
    x2: 61.4028,
    y2: 176.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_5_256",
    x1: 57.1864,
    y1: 161.383,
    x2: 68.9564,
    y2: 141.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_5_256",
    x1: 60.4204,
    y1: 152.166,
    x2: 67.0474,
    y2: 134.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_5_256",
    x1: 64.8372,
    y1: 149.187,
    x2: 67.5754,
    y2: 141.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_5_256",
    x1: 64.0453,
    y1: 148.155,
    x2: 67.0158,
    y2: 140.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_5_256",
    x1: 65.9149,
    y1: 142.253,
    x2: 69.4085,
    y2: 132.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_5_256",
    x1: 62.3448,
    y1: 191.429,
    x2: 72.2342,
    y2: 164.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_5_256",
    x1: 64.0247,
    y1: 167.386,
    x2: 66.3626,
    y2: 161.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_5_256",
    x1: 46.6993,
    y1: 146.62,
    x2: 44.112,
    y2: 167.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroThree);
export default __webpack_public_path__ + "static/media/introThree.d6ea9e1eb26149a3431095e934f1430a.svg";
export { ForwardRef as ReactComponent };